import { Component, registerComponent } from 'js/component.js';
import { getBreakpointMediaQuery } from 'js/constants.js';

const componentName = 'plex-footer';

export class PlexFooter extends Component {

    initialized = false;

    setup() {
        // Elements
        this.elements = {
            element: this.element,
            copyrightText: this.element.querySelector(`.${componentName}__copyright-text`),
            copyrightTextMobile: this.element.querySelector(`.${componentName}__copyright-text-mobile`),
            raLinkListTitle: this.element.querySelectorAll('.ra-link-list__title'),
            requestDemoLink: this.element.querySelector('.link__anchor[href="#request-a-demo"]'),
        };

        this.elements.copyrightText.textContent = this.elements.copyrightText.textContent.replace('YYYY', new Date().getFullYear());
        this.elements.copyrightTextMobile.textContent = this.elements.copyrightTextMobile.textContent.replace('YYYY', new Date().getFullYear());
    }

    addHeaderListeners() {
        const activeClass = `${componentName}--active`;
        this.elements.raLinkListTitle.forEach((el) => {
            el.addEventListener('click', (ev) => {
                if (getBreakpointMediaQuery('down', 'medium').matches) {
                    ev.stopPropagation();
                    ev.preventDefault();
                    el.parentElement?.classList.toggle(activeClass);
                    this.slideToggle(ev);
                }
            });
        });
        if (this.elements.requestDemoLink) {
            this.elements.requestDemoLink.addEventListener('click', (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                if (window.drift && window.drift.on) {
                    window.drift.api.startInteraction({ interactionId: 392880 });
                }
            });
        }
    }

    slideToggle(ev) {
        ev.preventDefault();
        const titleEl = ev.currentTarget;
        const listEl = titleEl.parentElement.querySelector('.ra-link-list__list');

        if (!listEl.classList.contains('active')) {
            listEl.classList.add('active');
            listEl.style.height = 'auto';

            const height = `${listEl.clientHeight}px`;
            listEl.style.height = '0px';

            setTimeout(() => {
                listEl.style.height = height;
            });
        } else {
            listEl.style.height = '0px';

            listEl.addEventListener('transitionend', () => {
                listEl.classList.remove('active');
            }, { once: true });
        }
    }

    // ==========
    // Editable Initial Editing
    // ==========
    editableInitialEditing = () => {
        if(!window.location.href.includes('config-pages/footer-config.html') && (document.querySelector('[data-path*="config-pages/footer-config"]') !== null)) {
            document.querySelectorAll('[data-path*="config-pages/footer-config"]').forEach((el) => {
                el.remove();
            });
            document.querySelectorAll('.plex-footer .authoring-component-label').forEach((el) => {
                el.remove();
            });
            document.querySelectorAll('.plex-footer .col-mobile .newpar.new.section').forEach((el) => {
                el.remove();
            });
            document.querySelectorAll('.plex-footer .col-mobile [data-emptytext="Link List"]').forEach((el) => {
                el.remove();
            });
        }
    };

    /**
     * Initialize Component
     */
    init() {
        const plexFooterElement = this.element;
        // Ensure this element is only initialized once
        if (plexFooterElement.dataset.initialized === 'true') {
            console.warn('Footer component already initialized for this element');
            return;
        }

        const accessibilityLink = document.querySelector(`${componentName} .px-footer-acsb-trigger`);
        // Add accessibility listener
        if (accessibilityLink) {
            accessibilityLink.addEventListener('click', (ev) => {
                ev.preventDefault();
                const crownpeakAcsbLink = document.querySelector('.acsb-trigger');
                if (crownpeakAcsbLink) {
                    crownpeakAcsbLink.click();
                }
            });
        }

        plexFooterElement.dataset.initialized = 'true';

        this.initialized = true; // Mark as initialized
        this.setup();
        this.editableInitialEditing();
        this.addHeaderListeners();
    }
}

export function initPlexFooter() {
    registerComponent(`plex-footer.${componentName}`, PlexFooter);
}

document.addEventListener('plex-footer-fragment-loaded', initPlexFooter);
initPlexFooter();
